__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/web-rel-26.6.1-87a810f-10893/_next/";